export { default } from './PropertyList';
